import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import * as echarts from 'echarts';
import { Dropdown, DropdownOption } from '@abb/abb-common-ux-react';
import "./enpi-monitoring.css";
import PeriodList from '../../Period-Dropdown-list/period-dropdown-list';
import enpiMonitoringJsonData from './enpi-monitoring.json';
import axios from 'axios';
import { getToken } from "../../Authentication/get-token";
import { BASE_URL } from '../../../strings';
import "./enpi-monitoring.css"
const ENPI_MONITORING = () => {
  const chartRef = useRef(null);
  const [apiData, setApiData] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchENPIData = useCallback(async () => {
    try {
      const token = await getToken();
      const response = await axios.get(`${BASE_URL}emapi/en_pi_monit`,getToken());
      setApiData(response.data.dataConfig || []);
    } catch (error) {
      console.error("Failed to fetch ENPI data:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchENPIData();
  }, [fetchENPIData]);

  const chartOptions = useMemo(() => {
    return {
      tooltip: {
        trigger: enpiMonitoringJsonData.tooltip.trigger
      },
      xAxis: {
        type: enpiMonitoringJsonData.xAxis.type,
        data: apiData.map(item => item.name),
        name: enpiMonitoringJsonData.xAxis.name,
        axisLabel: {
          padding: enpiMonitoringJsonData.xAxis.axisLabel.padding
        },
        nameLocation: enpiMonitoringJsonData.xAxis.nameLocation,
        axisTick: {
          alignWithLabel: true
        }
      },
      yAxis: {
        type: enpiMonitoringJsonData.yAxis.type,
        name: enpiMonitoringJsonData.yAxis.name,
        nameLocation: enpiMonitoringJsonData.yAxis.nameLocation,
        nameRotate: enpiMonitoringJsonData.yAxis.nameRotate,
        nameGap: 30,
        axisLabel: {
          padding: enpiMonitoringJsonData.yAxis.axisLabel.padding,
          verticalAlign: enpiMonitoringJsonData.yAxis.axisLabel.verticalAlign,
          lineHeight: enpiMonitoringJsonData.yAxis.axisLabel.lineHeight
        }
      },
      series: [{
        type: enpiMonitoringJsonData.series.type,
        data: apiData.map(item => item.value),
        itemStyle: {
          color: '#E12E2E'
        }
      }]
    };
  }, [apiData, enpiMonitoringJsonData]);

  useEffect(() => {
    if (!loading && chartRef.current) {
      const chart = echarts.init(chartRef.current);
      chart.setOption(chartOptions);
      return () => {
        chart.dispose();
      };
    }
  }, [chartOptions, loading]);

  const [dropdownValues, setDropdownValues] = useState(() =>
    enpiMonitoringJsonData.dropdowns.reduce((acc, dropdown) => {
      acc[dropdown.key] = dropdown.placeholder;
      return acc;
    }, {})
  );

  const handleDropdownChange = (key, value) => {
    setDropdownValues(prev => ({ ...prev, [key]: value }));
  };

  const dropdowns = useMemo(() => {
    return enpiMonitoringJsonData.dropdowns.map((dropdown, index) => (
      <Dropdown
        key={`dropdown-${dropdown.key}-${index}`}
        label={dropdown.label}
        placeholder={dropdown.placeholder}
        value={dropdownValues[dropdown.key]}
        onChange={(value) => handleDropdownChange(dropdown.key, value)}
      >
        {dropdown.options.map(option => (
          <DropdownOption key={option.key} label={option.label} value={option.value} />
        ))}
      </Dropdown>
    ));
  }, [enpiMonitoringJsonData.dropdowns, dropdownValues]);

  return (
    <div className='enpi-block'>
      <div className='indicator-container-line'>
        {dropdowns}
        <PeriodList />
      </div>
      <div ref={chartRef} style={{ width: '545px', height: '280px' }}>
        {loading && <p>Loading chart...</p>}
      </div>
    </div>
  );
};

export default ENPI_MONITORING;
